import { apiConstantsURL } from '../../constants';
import { axiosClient } from '../../utils/axiosClient';

export const saveProfile = async (datapayload) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.saveUserProfile,
    datapayload
  );
  return response;
};
export const saveProfileById = async (userId, datapayload) => {
  const response = await axiosClient.post(
    apiConstantsURL.account.saveProfileById + userId,
    datapayload
  );
  return response;
};
export const getUser = async (datapayload) => {
  const response = await axiosClient.get(
    apiConstantsURL.account.getUser,
    datapayload
  );
  return response;
};

export const getAllOrgUsers = async (
  pageNumber,
  pageSize,
  startDate,
  endDate,
  search
) => {
  let url =
    apiConstantsURL.account.getUserByPagination +
    pageNumber +
    `&noOfRecords=${pageSize}`;

  if (startDate && endDate) {
    url += `&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  }

  if (search && search.trim()) {
    url += `&search=${encodeURIComponent(search.trim())}`;
  }

  const response = await axiosClient.get(url);
  return response;
};

export const getUserByManager = async (datapayload) => {
  const response = await axiosClient.get(
    apiConstantsURL.account.getUserByManager,
    datapayload
  );
  return response;
};
export const assignManagerToUser = async (userId, managerId) => {
  const response = await axiosClient.get(
    apiConstantsURL.account.assignManagerToUser +
      userId +
      '&managerId=' +
      managerId
  );
  return response;
};
export const getManagerByOrgId = async () => {
  const response = await axiosClient.get(
    apiConstantsURL.account.getManagerByOrgId
  );
  return response;
};
export const getUserByOrg = async () => {
  const response = await axiosClient.get(apiConstantsURL.account.getUserByOrg);
  return response;
};
export const getUserByOrgId = async (orgId) => {
  const response = await axiosClient.get(
    apiConstantsURL.account.getUserByOrgId + orgId
  );
  return response;
};
export const getAllRoles = async () => {
  const response = await axiosClient.get(apiConstantsURL.account.getAllRoles);
  return response;
};

export const getNonUserGoalShares = async (orgId) => {
  const url = orgId
    ? `${apiConstantsURL.account.getNonUserGoalShares}?orgId=${orgId}`
    : apiConstantsURL.account.getNonUserGoalShares;
  const response = await axiosClient.get(url);
  return response;
};
